import { SVGProps, Ref, forwardRef } from 'react';

export const LiferingFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23 12c0 2.691-.659 5.383-2.298 7.43l-4.084-4.085c.625-.967.882-2.156.882-3.345s-.257-2.378-.882-3.345l4.084-4.085C22.342 6.617 23 9.31 23 12m-7.648-4.625 4.086-4.086C17.722 1.881 15.3 1 12 1s-5.722.88-7.438 2.29l4.086 4.085C9.473 6.83 10.572 6.5 12 6.5s2.527.33 3.352.875m-7.97 1.28L3.298 4.57C1.658 6.617 1 9.31 1 12s.658 5.383 2.298 7.43l4.084-4.085C6.757 14.378 6.5 13.189 6.5 12s.257-2.378.882-3.345m7.97 7.97c-.825.545-1.924.875-3.352.875s-2.527-.33-3.352-.875l-4.086 4.086C6.278 22.119 8.7 23 12 23s5.722-.88 7.438-2.29z"
                fill="currentColor"
            />
        </g>
    </svg>
));
LiferingFilledSize24Glyph.displayName = 'LiferingFilledSize24Glyph';
